// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"7e9c37a0df6a42b99c22","691":"d9d1ac2e14260125b043"}[chunkId] + ".js";
};